export default function initNav() {
  const toggleButton = document.querySelector('.nav__toggle');
  const navOverlay = document.querySelector('.nav__overlay');
  const body = document.body;

  if (!toggleButton || !navOverlay) {
    console.error('Required elements not found.');
    return;
  }

  const closeMenu = () => {
    toggleButton.setAttribute('aria-expanded', 'false');
    navOverlay.setAttribute('aria-hidden', 'true');
    body.classList.remove('no-scroll'); // Enable scrolling
  };

  const openMenu = () => {
    toggleButton.setAttribute('aria-expanded', 'true');
    navOverlay.setAttribute('aria-hidden', 'false');
    body.classList.add('no-scroll'); // Disable scrolling
  };

  const toggleMenu = () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // Ensure menu closes on desktop viewport
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 768) {
      closeMenu();
    }
  });

  // Close menu on outside click
  const handleClickOutside = (event) => {
    if (!navOverlay.contains(event.target) && !toggleButton.contains(event.target)) {
      closeMenu();
    }
  };

  // Close menu on Escape key
  const handleEscapeKey = (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  };

  toggleButton.addEventListener('click', toggleMenu);
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('keydown', handleEscapeKey);
}
